import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-panel pw100" };
const _hoisted_2 = { class: "main-panel-content" };
const _hoisted_3 = { class: "main-panel-body pad10" };
const _hoisted_4 = { class: "clearfix pad10" };
const _hoisted_5 = { class: "card-panel left pw100" };
const _hoisted_6 = { class: "text-center" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h2", { class: "emphasis" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-android" })
], -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("h2", { class: "emphasis" }, "Well, this was unexpected!", -1 /* HOISTED */);
const _hoisted_9 = { class: "top10" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tOur support team has been notified of this issue and will investigate it as soon as possible.\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tIn the meantime, you may wish to try the action again.\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tWe apologize for any inconvenience.\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("a", { class: "btn btn-success white-text" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-home" }),
    /*#__PURE__*/ _createTextVNode(" Home\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            _hoisted_8,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(),
                                _hoisted_11,
                                _createTextVNode(),
                                _hoisted_12,
                                _createTextVNode(),
                                _createVNode(_component_router_link, { to: { name: 'home' } }, {
                                    default: _withCtx(() => [
                                        _hoisted_13
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
